module.exports = "/_next/static/images/AzugaLogo2-1a957ab2043dd45e11dc069a533e48c9.jpg";